import { render, staticRenderFns } from "./IntegrationsError.vue?vue&type=template&id=40c93dcb&scoped=true&"
import script from "./IntegrationsError.vue?vue&type=script&lang=js&"
export * from "./IntegrationsError.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsError.vue?vue&type=style&index=0&id=40c93dcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c93dcb",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsError.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsError.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
